import * as React from 'react';
import { useIntl } from 'react-intl';
import { JRCFlexBox } from 'components/JRCFlex/JRCFlexBox';
import { JRCText } from 'components/JRCTypo/JRCTypo';

export const LabelDescriptionOption = {
    Option: ({ option }: { option: { label: string; description: string; recommended?: boolean } }) => {
        const intl = useIntl();

        return (
            <JRCFlexBox direction="column" gap={0} style={{ padding: '8px 0' }}>
                <JRCText>
                    {intl.formatMessage({ id: option.label })}
                    {option.recommended && <>&nbsp;({intl.formatMessage({ id: 'GLOBAL_Recommended' })})</>}
                </JRCText>
                {option.description && <JRCText size="s">{intl.formatMessage({ id: option.description })}</JRCText>}
            </JRCFlexBox>
        );
    },
};
